import { render, staticRenderFns } from "../../../pages/imagingEngineer/notic/notic.html?vue&type=template&id=6e2fa512&scoped=true&"
import script from "../../../pages/imagingEngineer/notic/notic.js?vue&type=script&lang=js&"
export * from "../../../pages/imagingEngineer/notic/notic.js?vue&type=script&lang=js&"
import style0 from "../../../pages/imagingEngineer/notic/notic.css?vue&type=style&index=0&id=6e2fa512&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2fa512",
  null
  
)

export default component.exports